import { ReferenceField, ReferenceFieldProps, TextField, TextFieldProps, FunctionField } from 'react-admin';
import Option from '../GeneratedModels/Option';

/**
 * Generated by Db2Ts @ 2023-06-12 15:11:1148
 */

interface OptionTextFieldProps extends Omit<TextFieldProps, "source"> {
  source: 'id' | 'is_public' | 'tree_node_parent_id' | 'tree_node_parent_order' | 'option_type' | 'name_en' | 'name_tc' | 'name_sc' | 'desc_en' | 'desc_tc' | 'desc_sc' | 'created' | 'createdBy' | 'updated' | 'updatedBy',
}

interface OptionReferenceFieldProps extends Omit<ReferenceFieldProps, 'children' | 'source' | 'reference'> {
  source?: string,
  reference?: string,
  textFieldProps?: OptionTextFieldProps
  render?: (record: Option) => string,
}

const OptionReferenceField = ({ source, reference, render, textFieldProps, ...rest }: OptionReferenceFieldProps) => {
  return (
    <ReferenceField {...rest} source={source ?? 'option_id'} reference={reference ?? 'option'}>
      {render
        ? <FunctionField render={render} />
        : <TextField {...textFieldProps} />
      }
    </ReferenceField>
  )
}

OptionReferenceField.defaultProps = {
  addLabel: true,
  // label: "Option",
  source: "option_id",
  reference: "option",
  textFieldProps: {
    source: 'name_tc',
  },
};

export default OptionReferenceField;
